<div class="[ container container-max-width-4xl stack ]">
  <h1 class="[ headline-large text-center ]">Bestand downloaden</h1>

  @if (isLoggedIn$ | async) {
    <div class="[ cluster ]">
      <div class="[ items-start justify-center ]">
        @if (url$ | async; as url) {
          <p
            >Indien de download niet automatisch start, <a [href]="url" target="_blank">klik hier</a>.</p
            >
          } @else {
            <p>Dit bestand is niet beschikbaar voor jouw account.</p>
          }
        </div>
      </div>
    } @else {
      <div class="[ stack items-center ]">
        <p>Je moet aangemeld zijn om deze pagina te bekijken.</p>
        <p><a [routerLink]="['/login']">Klik hier om aan te melden.</a></p>
      </div>
    }
  </div>
